"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _config = _interopRequireDefault(require("config"));

var _backboneRelational = _interopRequireDefault(require("backbone-relational"));

var _backboneValidation = _interopRequireDefault(require("backbone-validation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var FieldValue = _backbone.default.RelationalModel.extend({
  _validate: _underscore.default.wrap(_backbone.default.Model.prototype._validate, function (func, attrs, options) {
    _typeof(options) === 'object' && (options.validate = true);
    return func.call(this, attrs, options);
  }),
  validation: {
    'value': [{
      required: function required(value, attr, computedState) {
        return computedState.entityType == 'checkbox' || computedState.entityType == 'radio' || computedState.entityType == 'list';
      },
      msg: 'Choice can\'t be empty.'
    }, {
      maxLength: 500,
      msg: 'Choice name is too long'
    }]
  },
  toJSON: function toJSON() {
    var toJSON = _backbone.default.RelationalModel.prototype.toJSON.call(this);

    if (_typeof(toJSON) === 'object') {
      // It can be a number because sometimes RelationalModel#toJSON returns model's id
      toJSON.form = null;
    }

    return toJSON;
  }
});

var _default = FieldValue;
exports.default = _default;